import Component from './pagination.vue'
export default Component
